import * as React from 'react';
import StopWatchVisual from '~/components/StopWatchVisual';
import { useAlertBackground } from '@ixicare/ui';
import { t } from '~/i18n';
import { observer } from 'mobx-react';
import Alert from '~store/Alert/Alert';

interface AlertStopWatchContainerProps {
  alert: Alert;
}

const AlertStopWatchContainer: React.FC<AlertStopWatchContainerProps> = ({ alert }) => {
  const stopWatchStyle = useAlertBackground(alert.priority);

  return (
    <StopWatchVisual
      label={t('alert.detail.time.alert')}
      start={alert.created}
      end={alert.resolvedTime ?? alert.acceptedTime ?? alert.cancelledTime ?? undefined}
      stopWatchStyle={stopWatchStyle}
    />
  );
};

export default observer(AlertStopWatchContainer);
